import apiClient from '../../../services/apiClient';

type EmailTemplatePreviewResponse = {
  emails: { content: { html: string } }[];
};

export const getEmailTemplatePreview = (
  orgId: string,
  templateName: string,
  data: { [key: string]: string },
  emails = ['email@address.com']
): Promise<EmailTemplatePreviewResponse> =>
  apiClient
    .post<EmailTemplatePreviewResponse>('/v1/template/preview', { templateName, orgId, emails, data })
    .then(response => response.data);
